// import GptPulseService from '@/services/API/GptPulse';

import { dateprintDefault } from '@/utils/dateprint';

import Base from '../Base';

export const CONFERENCE_SOURCE = {
  telegram: 1,
  jazz: 2,
};

export const CONFERENCE_SOURCE_LABEL = {
  [CONFERENCE_SOURCE.telegram]: 'Telegram трансляция',
  [CONFERENCE_SOURCE.jazz]: 'Sber Jazz трансляция',
};

export const CONFERENCE_TELEGRAM_TYPE = {
  course: 1,
  group: 2,
  user: 3,
  enrollment: 4,
};

export default class ChatMessage extends Base {
  constructor(item) {
    super(item.id, '/chat-message');
    this.id = item.id;
    this.title = item.title;
    this.conference = item.conference;
    this.type = CONFERENCE_SOURCE.telegram;
    this.date_start = dateprintDefault(`${item.date_start}`);
    this.date_end = dateprintDefault(`${item.date_end}`);
    this.dateStart = item.date_start;
  }

  openDeleteModal(id, type) {
    const service = type === CONFERENCE_SOURCE.telegram ? 'telegram' : 'schedule';
    this.$modals.show('confirm-controller', {
      type: 'error',
      title: 'Удаление конференции',
      message: 'Подтвердите удаление конференции',
      method: async () => {
        await this.$api[service].conferenceDelete(id);
        const idx = this.lessons.findIndex((i) => i.id === id);
        this.lessons.splice(idx, 1);
        this.$modals.close();
        this.$toasted.success('Конференция успешно удалена');
      },
    });
  }
}
